import React from 'react';
import { Navigate } from 'react-router-dom';

const PrivateRoute = ({ element, authenticated, authToken, redirectTo = '/login' }) => {
  if (authenticated && authToken) {
    return element; 
  } else {
    return <Navigate to={redirectTo} replace />; 
  }
};

export default PrivateRoute